import { Service } from './service';

export class ServiceGroup {
  groupName: string;
  groupNameDe: string;
  iconId: string;
  services: Service[];
  sortOrder: number;
}
